import * as React from 'react';
import { Button, ButtonSize, ButtonVariant, IconName, useTheme } from '@secretescapes/falcon';
import { i18n } from '@secretescapes/i18n';
import { useTranslations } from '@utils/useTranslations';
import { InteractionButtons } from '@features/Sale/InteractionButtons';
import { HeaderContainer } from './GalleryModal.styles';

interface Props {
  handleBackClick: () => void;
  saleId: string;
  saleTitle: string;
  isFavourite: boolean;
  isMobile: boolean;
}

export const ModalHeader = React.forwardRef<HTMLDivElement, Props>(
  ({ handleBackClick, saleId, saleTitle, isFavourite, isMobile }: Props, ref) => {
    const { color } = useTheme();
    const { translations } = useTranslations();

    return (
      <HeaderContainer ref={ref}>
        <Button
          leftIcon={IconName.chevronLeft}
          onClick={handleBackClick}
          variant={isMobile ? ButtonVariant.textWhite : ButtonVariant.textBlack}
          size={ButtonSize.small}
        >
          {i18n('mobile.backButton', [], translations)}
        </Button>
        <InteractionButtons
          saleId={saleId}
          saleTitle={saleTitle}
          isFavourite={!!isFavourite}
          isMobile={isMobile}
          shareIconColor={isMobile ? color.white : color.blackText}
        />
      </HeaderContainer>
    );
  }
);

ModalHeader.displayName = 'ModalHeader';
